var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "device-sort" } },
    [
      _c("hr", { staticClass: "separator separator--gray4" }),
      _vm._v(" "),
      _c("ob1-radio-button-list", {
        staticClass: "ms-1",
        attrs: { "radios-buttons": _vm.sortRadioButtons },
        on: { change: _vm.sortMobilesSelected },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }